module.exports = __webpack_public_path__ + "img/bg1.058db7c2.jpg";